import JobCategory from ".";

export const jobCategoryRoutes = () => [
  {
    path: "/admin/job-categories",
    component: JobCategory,
    layout: "admin",
    routeType: "admin",
    title: "Jobs Management",
  },
];
